// ADD listeners to modal buttons
document.addEventListener("DOMContentLoaded", () => {

  const handleEventTrigger = (event) => {
    let trigger = event.currentTarget;
    event.preventDefault();
    let modal = document.getElementById(trigger.dataset.modal);
    modal.showModal();
  };

  const modalButtonObserver = (btns) => {
    btns.forEach(function (trigger) {
      trigger.removeEventListener("click", handleEventTrigger);
      trigger.addEventListener("click", handleEventTrigger);
    });
  };

  const modalButtonObserverCallback = () => {
    const btnModals = document.querySelectorAll("[data-modal]");
    if (btnModals.length > 0) {
      modalButtonObserver(btnModals);
    }
  };

  const modalButtonObserverOptions = {
    childList: true,
    attributes: true,
    attributeFilter: ["data-modal"],
    subtree: true,
  };

  const observer = new MutationObserver(modalButtonObserverCallback);
  observer.observe(document.body, modalButtonObserverOptions);

});
